// required by pages (getInitialProps)
import bog from './moreBog';

const API_HOT_PREFIX = 'apiHotCache';
const API_COLD_PREFIX = 'apiColdCache';
const COLD_CACHE_MAX_AGE = 604800; // 1 week
const HOT_CACHE_MAX_AGE = 60; // align with page cache in redis
const dev = process.env.NODE_ENV !== 'production';

let apiColdCacheWriter;
let apiColdCacheReader;
let apiHotCacheWriter;
let apiHotCacheReader;

// server only! NO CACHE on client-side !!
if (typeof window === 'undefined' && !dev) {
  // MUST BE standard lru-cache because it caches promises, not html.
  const KVCache = require('cacheman');
  const { REDIS_READ_ENGINE, REDIS_WRITE_ENGINE } = require('./redisManager');
  apiColdCacheWriter = new KVCache(API_COLD_PREFIX, {
    engine: REDIS_WRITE_ENGINE,
    ttl: COLD_CACHE_MAX_AGE,
  });
  apiColdCacheReader = new KVCache(API_COLD_PREFIX, {
    engine: REDIS_READ_ENGINE,
    ttl: COLD_CACHE_MAX_AGE,
  });
  apiHotCacheWriter = new KVCache(API_HOT_PREFIX, {
    engine: REDIS_WRITE_ENGINE,
    ttl: HOT_CACHE_MAX_AGE,
  });
  apiHotCacheReader = new KVCache(API_HOT_PREFIX, {
    engine: REDIS_READ_ENGINE,
    ttl: HOT_CACHE_MAX_AGE,
  });
}

export default async (key, getter, validator = () => true) => {
  // no need to cache on client-side.
  if (typeof window !== 'undefined' || dev) return getter();
  const hotCache = await apiHotCacheReader.get(key);
  if (hotCache) {
    return hotCache;
  }

  try {
    const promise = getter();

    // wait for promise to resolve, it may error and fall through to `catch`
    const response = await promise;
    // catch middle api error
    if (!validator(response)) {
      bog.error('GwRequest error, result is ', key, JSON.stringify(response));
      throw new Error(`GwRequest error, url is ${key}, response is ${JSON.stringify(response)}`);
    }
    // success, add to cold cache
    // set latest correct result to coldCache
    apiHotCacheWriter.set(key, response);
    apiColdCacheWriter.set(key, response);
    return response; // success
  } catch (err) {
    // fall back to cold cache
    const coldCache = await apiColdCacheReader.get(key);
    if (!coldCache) {
      bog.error(
        'no cache found, throwing error',
        `key: ${key}`,
        err,
      );
      throw err;
    }
    bog.info('cold cache hit');
    bog.warn(
      'API call failed, cold cache has usable promise?',
      !!coldCache,
      key,
      err,
    );
    // set hot cache to cold cache when there is any error
    apiHotCacheWriter.set(key, coldCache);
    return coldCache;
  }
};
